import React, { useState } from "react";
import Sidebar from "./Sidebar"; // Import Sidebar Component
import Header from "./Header"; // Import Header Component
import ClientsTable from "../clients/ClientsTable";


const UserClientPage = () => {
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);

  // Toggle sidebar visibility
  const toggleSidebar = () => setIsSidebarClosed(!isSidebarClosed);

  return (
    <div className="flex flex-col md:flex-row h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar isSidebarClosed={isSidebarClosed} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header toggleSidebar={toggleSidebar} />

        {/* Content Section */}
        <main className="flex-1 p-4 md:p-8 overflow-auto">
          <ClientsTable />
          
        </main>
      </div>
    </div>
  );
};

export default UserClientPage;
